import { render, staticRenderFns } from "./RoomTable.vue?vue&type=template&id=5b4de0ac&scoped=true&"
import script from "./RoomTable.vue?vue&type=script&lang=js&"
export * from "./RoomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4de0ac",
  null
  
)

export default component.exports